import uuidv4 from 'uuid/v4';

let initialState = {
  stack: [],
};

export const ISSUE_ALERT = 'ISSUE_ALERT';
export const DISMISS_ALERT = 'DISMISS_ALERT';

export const getAlert = state => {
  const n = state.alerts.stack.length;
  return n === 0 ? null : state.alerts.stack[n - 1];
};

export const issueAlert = (message, kind) => {
  return {
    type: ISSUE_ALERT,
    message: message,
    kind: kind,
  };
};

export const dismissAlert = id => {
  return { type: DISMISS_ALERT, id: id };
};

const doIssueAlert = (state, action) => {
  const alerts = state.stack.concat([{
    message: action.message,
    kind: action.kind,
    id: uuidv4(),
  }]);
  return Object.assign({}, state, { stack: alerts });
};

const doDismissAlert = state => {
  const n = state.stack.length;
  if (n === 0) {
    return state;
  }
  const alerts = state.stack.slice(0, n - 1);
  return Object.assign({}, state, { stack: alerts });
};

export default (state = initialState, action) => {
  switch (action.type) {
  case ISSUE_ALERT:
    return doIssueAlert(state, action);
  case DISMISS_ALERT:
    return doDismissAlert(state, action);
  default:
    return state;
  }
};
